import React from 'react';
import { AUTOFRAMED_CAPTIONS_INFOBOX_MESSAGE_EDIT } from 'constants/autoframing';
import BaseEditCaptionsModal, {
  EditCaptionsModalContainerProps,
} from 'containers/EditCaptionsModal';
import { isCaptionsSourceVideoAutoframed } from 'utils/embed/captions';
import { useEditorState } from '../context/VideoEditorStateContext/VideoEditorStateContext';

const EditCaptionsModal: React.FC<EditCaptionsModalContainerProps> = props => {
  const editorState = useEditorState();
  const defaultEmbedConfig = editorState?.defaultEmbedConfig;

  const isAutoframed = isCaptionsSourceVideoAutoframed(defaultEmbedConfig);

  const infoboxMessage = isAutoframed
    ? AUTOFRAMED_CAPTIONS_INFOBOX_MESSAGE_EDIT
    : null;

  return (
    <BaseEditCaptionsModal {...props} canvasInfoboxMessage={infoboxMessage} />
  );
};

export default EditCaptionsModal;
